import type * as ds from '@attain-apps/fe/web/main/lib/design'
import type * as router from '@attain-apps/fe/web/main/lib/router'

import type * as me from '../../../../../me'
import type * as currentRendering from '../../feature'

import type { Feature } from './feature'

export class Selectors {
  /** TODO:  explain why private */
  private readonly _segmentInfoLookup
  /** TODO: explain why private */
  private readonly _segments

  /** TODO:  */
  public readonly segmentsThatRequireRendering
  /** TODO:  */
  public readonly getInfo
  /** TODO:  */
  private readonly _currentSegment
  /** TODO:  */
  public readonly currentSegmentBreadcrumbs

  /**
   * Signal indicating whether any segment is currently in a loading state.
   * Useful for showing a global loading indicator while at least one segment is loading.
   */
  public readonly someLoading

  constructor(
    feature: Feature,
    currentRenderingFeature: currentRendering.Feature,
    routerFeature: router.Router,
    meFeature: me.Feature,
  ) {
    this._segmentInfoLookup = feature.state.project(
      state => state.segmentInfoLookup,
    )

    this._segments = currentRenderingFeature.selectors.rendering.project(
      rendering => rendering?.content.segments ?? [],
    )

    this.segmentsThatRequireRendering = this._segments.project(segments =>
      segments.filter(segment => segment.hasQuery),
    )

    this.getInfo = feature.createSelectorMethod(
      ({ alias }: { alias: string }) =>
        this._segmentInfoLookup.project(
          segmentInfoLookup => segmentInfoLookup[alias],
        ).asSelector,
    )

    this.someLoading = this._segmentInfoLookup.project(segmentInfoLookup =>
      Object.values(segmentInfoLookup).some(segment => !!segment?.isLoading),
    )

    this._currentSegment = this._segments.project(
      routerFeature.selectors.fragment.asSelector,
      (segments, alias) =>
        alias === undefined
          ? segments[0]
          : segments.find(segment => segment.alias === alias),
    )

    this.currentSegmentBreadcrumbs = this._currentSegment.project(
      this._segmentInfoLookup.asSelector,
      (state: object) => state,
      (segment, segmentLookup, state) =>
        segment?.alias === undefined
          ? []
          : (segmentLookup[
              segment.alias
            ]?.rendering?.breadcrumbs?.map<ds.layout.page.child.header.models.Breadcrumb>(
              raw => ({
                name: raw.name,
                url: meFeature.contexts.selectors
                  .getUrlForLink({ goto: raw.goto })
                  .asSelector(state),
              }),
            ) ?? []),
    )
  }
}
